<template>
  <div class="asso-event-info-portal">
    <NewSponsor :eventId="eventId" :association_id="association_id" />
    <EditSponsor :eventId="eventId" :association_id="association_id" />
    <ManageParks :eventId="eventId" :association_id="association_id" />
    <NewHotel :eventId="eventId" :association_id="association_id" />
    <EditHotel :eventId="eventId" :association_id="association_id" />
    <!-- <EditEventDetailModal :association_id="association_id" /> -->
    <div class="asso-right-part-sec">
      <div class="details-info asso-sec-content" v-if="events && showLoader == 0">
        <div class="d-flex align-items-center justify-content-between" style="gap:10px">
          <h6>Details</h6>
          <button class="create-event" @click="callModal(events)" v-if="currentIsAdmin == '1'">
            <img src="../../assets/images/edit.png" class="mr-1" alt="edit" style="width: 20px; height: 20px;" />
            <span>Edit</span>
          </button>
        </div>
        <div class="info-sec">
          <div class="info">
            <img src="../../assets/Svg/unfollow.svg" />
            <div class="info-part">
              <span>{{ events.event_follower_count }} people following</span>
            </div>
          </div>
          <div class="info" v-if="events.director_name || events.director_phone || events.director_email">
            <img src="../../assets/Svg/security-user.svg" />
            <div class="info-part">
              <span>Director: </span>
              <span>{{ events.director_name }}</span><br />
              <span>{{ events.director_phone }}</span><br />
              <span>{{ events.director_email }}</span>
            </div>
          </div>
          <div class="info" v-if="events.entry_fee">
            <img src="../../assets/Svg/dollar-circle.svg" />
            <div class="info-part">
              <span>Entry Fee </span>
              <span class="font-bold">{{ events.entry_fee }}</span>
            </div>
          </div>
          <div class="info" v-if="events.entry_fee_deadline">
            <img src="../../assets/Svg/calendar.svg" />
            <div class="info-part">
              <span>Entry Deadline </span>
              <span class="font-bold">{{ formatDateDetail(events.entry_fee_deadline) }}</span>
            </div>
          </div>
          <div class="info" v-if="events.selected_seed_criteria && events.selected_seed_criteria.length">
            <img src="../../assets/Svg/seed-criteria.svg" />
            <div class="info-part">
              <span>Seed </span>
              <span>
                {{events.selected_seed_criteria.map(c => c.seed_criteria_name.criteria_name).join(', ')}}
              </span>
            </div>
          </div>
          <div class="info" v-if="events.game_guarantee && events.division_type">
            <img src="../../assets/Svg/event-format.svg" />
            <div class="info-part">
              <span>Format </span>
              <span>{{ events.game_guarantee }} games round robin to seed {{ events.eventName }} {{ events?.bracket_format?.bracket_name }} bracket.</span>
            </div>
          </div>
          <div class="info" v-if="events.pool_play_time && events.bracket_time && events.championship_time">
            <img src="../../assets/Svg/timer-event.svg" />
            <div class="info-part">
              <span>Time Limit </span>
              <span>RR = {{ events.pool_play_time }} + open inn, Bracket = {{ events.bracket_time}} + open inn, Championship = {{ events.championship_time }} + open inn.</span>
            </div>
          </div>
          <p>
            {{ events.note }}
            <span v-if="!isExpanded && (events.reminder !== null || events.tournament_format !== null || events.refund_policy !== null)" @click="isExpanded = true" class="read-more"
              style="cursor: pointer; color: #188ef5; font-weight: 600;">
              See More
            </span>
          </p>
        </div>
        <div class="info-sec" v-if="isExpanded">
          <div class="info" v-if="events.reminder">
            <div class="info-part">
              <span>Reminder: </span>
              <span class="font-bold">{{ events.reminder }}</span>
            </div>
          </div>
          <div class="info" v-if="events.refund_policy">
            <div class="info-part">
              <span>Refund Policy: </span>
              <span class="font-bold">{{ events.refund_policy }}</span>
            </div>
          </div>
          <div class="info" v-if="events.tournament_format">
            <div class="info-part">
              <span>Tournament Format: </span>
              <span class="font-bold">{{ events.tournament_format }}</span>
            </div>
          </div>
          <span @click="isExpanded = false" v-if="events.reminder !== null || events.tournament_format !== null || events.refund_policy !== null ||
            (events.selected_seed_criteria && events.selected_seed_criteria.length > 0) ||
            (events.game_guarantee && events.division_type)" class="read-more"
            style="cursor: pointer; color: #188ef5; font-weight: 600;">
            See Less
          </span>
        </div>
      </div>

      <div class="location-wrap-content mt-3" v-if="events && showLoader == 0">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <h6>{{ events.status == 1 ? 'Location' : 'Link' }}</h6>
          <span class="reset-button get-direc" @click="openGoogleMap(events)" v-if="events.status == 1">Get
            Directions</span>
        </div>
        <div class="event-list-details event-info-wrap">
          <p @click="openGoogleMap(events)" class="location-content" v-if="
            (events.status == 1 &&
              events.address != null &&
              events.address != '' &&
              events.address != 'null') ||
            (events.city != null &&
              events.city != '' &&
              events.city != 'null') ||
            (events.state != null &&
              events.state != '' &&
              events.state != 'null')
          ">
            <img src="../../assets/Svg/location.svg" />
            <span>{{ events.address }} {{ events.city }},
              {{ events.state }}</span>
          </p>
          <span class="location-content" v-if="events.status == 2">
            <img src="../../assets/images/link.png" />
            <a :href="events.Url" target="_blank" class="mx-0 font-weight-normal">
              {{ events.Url }}
            </a>
          </span>
          <div class="weather-sec" v-if="events.status == 1">
            <WeatherData v-if="isEventWithinFiveDays(events)" :eventId="events.id" />
          </div>
          <div class="row no-gutters" v-if="events.status == 1">
            <div class="col-12" v-if="
              (events.status == 1 &&
                events.address != null &&
                events.address != '' &&
                events.address != 'null') ||
              (events.city != null &&
                events.city != '' &&
                events.city != 'null') ||
              (events.state != null &&
                events.state != '' &&
                events.state != 'null')
            ">
              <google-map :center="marker.position" :zoom="15" map-style-id="roadmap" :options="mapOptions"
                style="width: 100%; height: 45vmin" ref="mapRef" id="map">
                <google-maps-marker :position="marker.position" :clickable="true" :draggable="false"
                  @drag="handleThrottledMarkerDrag" @click="panToMarker"></google-maps-marker>
              </google-map>
            </div>
          </div>
        </div>
      </div>
      <div class="products-list-shim details-info" v-if="showLoader == 1">
        <content-placeholders :rounded="true">
          <content-placeholders-heading />
        </content-placeholders>
      </div>
      <div class="row no-gutters">

        <div class="col-12 mt-3 asso-sec-content">

          <div class="products-list-shim p-0" v-if="eventPlayingFacility.length == 0 && playingFacilityLoader == 1">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
            </content-placeholders>

          </div>

          <div class="playing-wrapper" v-else-if="eventPlayingFacility.length == 0 && playingFacilityLoader == 0">
            <div class="top">
              <h6>Playing Facilities</h6>
              <button class="btn btn-primary" @click="manageParks()" v-if="currentIsAdmin == '1'">Manage Parks</button>
            </div>
            <div class="ground-info">
              <div class="text-center w-100">
                <p class="">No playing facilities added to this event yet.</p>
              </div>
            </div>

          </div>

          <div class="playing-wrapper" v-else>
            <div class="top">
              <h6>Playing Facilities</h6>
              <button class="btn btn-primary" @click="manageParks()" v-if="currentIsAdmin == '1'">Manage Parks</button>
            </div>
            <div class="ground-info" v-for="(playingFacility, index) in eventPlayingFacility" :key="index">
              <div class="park-location">
                <div class="park-img">
                  <img src="../../assets/images/baseball_field.png" alt="" />
                </div>
                <div class="park-info-sec">
                  <h6>{{ playingFacility?.park_name }}</h6>
                  <div class="park-info-sec-loc cursor-pointer" @click="openGoogleMapforGamePark(playingFacility)"
                    v-if="playingFacility?.park_name">
                    <img src="../../assets/images/location.png" />
                    <p>
                      <span v-if="playingFacility?.address">{{ playingFacility.address }}</span>
                      <span v-if="playingFacility?.number"> , {{ playingFacility.number }} </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="park-edit-btn d-none">
                <img src="../../assets/images/edit.png" alt="" />
              </div>
            </div>

          </div>

        </div>

        <div class="col-12 mt-3 asso-sec-content">
          <div class="products-list-shim p-0" v-if="eventHotels.length == 0 && hotelLoader == 1">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
            </content-placeholders>

          </div>
          <div class="sponsor-wrapper" v-else-if="eventHotels.length == 0 && hotelLoader == 0">
            <div class="top">
              <h6>Hotels</h6>
              <button class="btn btn-primary" @click="newHotel()" v-if="currentIsAdmin == '1'">Add Hotel</button>
            </div>
            <div class="row no-gutters">
              <div class="text-center w-100">
                <p class="">No hotels added to this event yet.</p>
              </div>

            </div>
          </div>


          <div class="hotel-wrapper" v-else>
            <div class="top">
              <h6>Hotels</h6>
              <button class="btn btn-primary" @click="newHotel()" v-if="currentIsAdmin == '1'">Add Hotel</button>
            </div>
            <div class="ground-info" v-for="(hotel, index) in eventHotels" :key="index"
              :style="{ cursor: hotel.website_url ? 'pointer' : 'default' }">
              <div class="park-location hotel-loc">
                <div class="park-hotel-img" v-if="hotel.image_url">
                  <img :src="hotelURL + hotel.image_url" alt="Hotel Image" />
                </div>
                <div class="park-img hotel-img" v-else>
                  <img src="../../assets/images/sponsor.png" alt="" />
                </div>
                <div class="park-info-sec hotel-info-sec">
                  <h6>{{ hotel.name }}</h6>
                  <div class="park-info-sec-loc" @click="openGoogleMapforHotel(hotel)">
                    <img src="../../assets/images/location.png" alt="" />
                    <p> {{ hotel.street_address }} . {{ hotel.city }} {{ hotel.state }}, {{ hotel.zip }}</p>
                  </div>
                </div>
              </div>
              <div class="park-edit-btn" @click="editHotel(hotel)" v-if="currentIsAdmin == '1'">
                <img src="../../assets/images/edit.png" alt="" />
              </div>
              <p class="hotel-content">
                {{ hotel.notes }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 mt-3 asso-sec-content">
          <div class="products-list-shim p-0" v-if="eventSponsors.length == 0 && sponsorLoader == 1">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
            </content-placeholders>

          </div>

          <div class="sponsor-wrapper" v-else-if="eventSponsors.length == 0 && sponsorLoader == 0">
            <div class="top">
              <h6>Sponsors</h6>
              <button class="btn btn-primary" @click="newSponsor()" v-if="currentIsAdmin == '1'">Add Sponsor</button>
            </div>
            <div class="row no-gutters">
              <div class="text-center w-100">
                <p class="">No sponsors added to this event yet.</p>
              </div>

            </div>
          </div>

          <div class="sponsor-wrapper" v-else>
            <div class="top">
              <h6>Sponsors</h6>
              <button class="btn btn-primary" @click="newSponsor()" v-if="currentIsAdmin == '1'">Add Sponsor</button>
            </div>
            <div class="sponsor-wrap">
              <div class="sponsor-content" v-for="(sponsor, index) in eventSponsors" :key="index"
                :style="{ cursor: sponsor.website_url ? 'pointer' : 'default' }">
                <div class="sponsor-info">
                  <div class="sponsor-img" v-if="sponsor.image_url">
                    <img :src="sponserURL + sponsor.image_url" alt="Sponsor Image" />
                  </div>
                  <div class="sponsor-img default-wrap" v-else>
                    <img class="default-image" src="../../assets/images/sponsor.png" alt="" />
                  </div>
                  <div class="edit-sponsor">
                    <img src="../../assets/images/edit.png" alt="" @click="editSponsor(sponsor)"
                      v-if="currentIsAdmin == '1'" />
                  </div>
                </div>
                <p class="sponsor-name" @click="openSponsorUrl(sponsor.website_url)">{{ sponsor.name }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import EditHotel from './Modals/EditHotel.vue';
import EditSponsor from './Modals/EditSponsor.vue';
import ManageParks from './Modals/ManageParks.vue';
import NewHotel from './Modals/NewHotel.vue';
import NewSponsor from './Modals/NewSponsor.vue';
import WeatherData from "@/components/NewGameTime/Events/WeatherData.vue";

export default {
  components: { NewSponsor, EditSponsor, ManageParks, NewHotel, EditHotel, WeatherData },
  name: "AssociationEventInfo",
  data() {
    return {
      sponserURL: this.$eventSponserStorageURL,
      hotelURL: this.$eventHotelStorageURL,
      isExpanded: false,
      marker: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: false,
        gestureHandling: 'cooperative', // allows zooming only with Ctrl + wheel on desktop
        disableDoubleClickZoom: true, // disables zoom on double-click
      },
      deviceTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Storage_URL: this.$googleMapApi,
      latLng: {},
      userInteracted: false,
    };
  },
  props: {
    events: {
      type: Object,
    },
    showLoader: {
      type: Number
    },
    eventId: {
      type: [Number, String],
    },
    eventSponsors: {
      type: Array
    },
    eventHotels: {
      type: Array
    },
    sponsorLoader: {
      type: Number
    },
    hotelLoader: {
      type: Number
    },
    currentIsAdmin: {
      type: String,
    },
    association_id: {
      type: [Number, String],
    },
    eventPlayingFacility: {
      type: Array
    },
    playingFacilityLoader: {
      type: Number
    },
  },
  watch: {
    events: {
      handler(newVal) {
        if (newVal) {
          let lat = parseFloat(newVal.lan);
          let lng = parseFloat(newVal.long);
          this.marker.position = {
            lat: lat,
            lng: lng,
          };
          this.panToMarker();
        }
      },
      immediate: true, // triggers the handler immediately if the prop already has a value
      deep: true       // optional: use if `events` is a nested object and you want to detect internal changes
    }
  },
  methods: {
    callModal(data) {
      this.$root.$emit("updateEditEventDetailModal", data);
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options); // Adjust 'undefined' to specify a locale if needed
    },
    formatDateDetail(dateString) {
      if (!dateString) return "Invalid Date";

      const [year, month, day] = dateString.split("-");

      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      const monthIndex = parseInt(month, 10) - 1;
      const formattedMonth = monthNames[monthIndex];

      return `${formattedMonth} ${parseInt(day, 10)}, ${year}`;
    },

    openGoogleMapforHotel(item) {
      const strlatLng = item["latitude"] + "," + item["longitude"];
      const urlSuffix = strlatLng ? strlatLng : item["address"] + ", " + item["city"] + ", " + item["address"] + ", " + item["zipCode"];

      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },

    openGoogleMapforGamePark(item) {
      const strlatLng = item["lat"] + "," + item["lng"];
      const urlSuffix = strlatLng ? strlatLng : item["address"] + ", " + item["city"] + ", " + item["address"] + ", " + item["zipCode"];

      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },

    openGoogleMap(item) {
      const strlatLng = item["lan"] + "," + item["long"];
      const urlSuffix = strlatLng
        ? strlatLng
        : item["address"] + ", " + item["city"] + ", " + item["zipCode"];

      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },

    openSponsorUrl(websiteUrl) {
      if (websiteUrl) {
        // Check if the URL already starts with http or https
        const formattedUrl = websiteUrl.startsWith('http://') || websiteUrl.startsWith('https://')
          ? websiteUrl
          : `https://${websiteUrl}`;
        window.open(formattedUrl, '_blank');
      }
    },

    newSponsor() {
      this.$root.$emit("openNewSponsorModal");
    },

    editSponsor(sponsor) {
      // Emit the "openEditSponsorModal" event along with the sponsor data
      this.$root.$emit("openEditSponsorModal", sponsor);
    },
    manageParks() {
      this.$root.$emit("openManageParksModal", {
        eventId: this.eventId,
        association_id: this.association_id
      });
    },

    newHotel() {
      this.$root.$emit("openNewHotelModal");
    },

    editHotel(hotel) {
      this.$root.$emit("openEditHotelModal", hotel);
    },

    panToMarker() {
      if (this.marker?.position) {
        this.$refs.mapRef?.panTo(this.marker.position);
      }
    },
    //Moves the marker to click position on the map
    handleMapClick(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === "OK") {
          if (results[0]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "locality"
                  ) {
                    window.test.city =
                      results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] ==
                    "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "postal_code"
                  ) {
                    window.test.zipCode =
                      results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
    },
    isEventWithinFiveDays(event) {
      if (!event?.startDate || !event?.endDate) return false;

      if (event.status === '2' && event.Url) {

        return false;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Function to safely convert date strings like "Tue Apr 16 2025 00:00:00 GMT Brasilia Standard Time"
      const safeParseDate = (dateStr) => {
        // Remove anything after 'GMT' to avoid timezone name issues
        const cleanedStr = dateStr.replace(/GMT.*/, 'GMT');
        const parsedDate = new Date(cleanedStr);
        return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
      };

      const startDate = safeParseDate(event.startDate);
      const endDate = safeParseDate(event.endDate);

      const diffStart = (startDate - today) / (1000 * 60 * 60 * 24);
      const diffEnd = (endDate - today) / (1000 * 60 * 60 * 24);

      const startsWithinFiveDays = diffStart >= 0 && diffStart <= 5;
      const endsWithinFiveDays = diffEnd >= 0 && diffEnd <= 5;
      const ongoingToday = today >= startDate && today <= endDate;

      return startsWithinFiveDays || endsWithinFiveDays || ongoingToday;
    },
    handleThrottledMarkerDrag: _.throttle(function (event) {
      this.handleMarkerDrag(event);
    }, 50),
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === "OK") {
          if (results[1]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "locality"
                  ) {
                    window.test.city =
                      results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route" ||
                results[i]?.types[0] == "neighborhood"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] ==
                    "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state =
                      results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {





                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "postal_code"
                  ) {
                    window.test.zipCode =
                      results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
    },
  },
};
</script>